import Cookies from 'js-cookie';

export default {
	state:{
		size:Cookies.get('size') || 'medium',
		requestLoading:0,
		backendMsgType:'',
		backendMsg:'',
		theme:{},
	},
	mutations:{
		SET_LOADING:(state, status)=>{
			// error 的时候直接重置
			if (status === 0) {
				state.requestLoading = 0;
				return;
			}
			state.requestLoading = status ? ++state.requestLoading :--state.requestLoading;
		},
		SET_BACKENDMSGTYPE:(state, msgType)=>{
			state.backendMsgType = msgType;
		},
		SET_BACKENDMSG:(state, msg)=>{
			state.backendMsg = msg;
		},
		SET_THEME:(state, theme)=>{
			state.theme = theme;
		},
	},
	actions:{
		SetLoading({ commit }, status) {
			commit('SET_LOADING', status);
		},
		SetBackendMsgType({ commit }, msgType) {
			commit('SET_BACKENDMSGTYPE', msgType);
		},
		SetBackendMsg({ commit }, msg) {
			commit('SET_BACKENDMSG', msg);
		},
		SetTheme({ commit }, theme) {
			commit('SET_THEME', theme);
		},
	},
};


// WEBPACK FOOTER //
// ./src/store/modules/app.js